<script setup>
import { useRoute, useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'fill',
    subject: 'Checklist',
  },
})

const route = useRoute('checklist-fill-template-id')
const router = useRouter()
</script>

<template>
  <div>
    <div class="d-flex align-center gap-3 mb-4">
      <VBtn
        icon="ri-arrow-left-line"
        variant="text"
        @click="router.push({ name: 'checklist-templates' })"
      />
      <div>
        <h4 class="text-h4 font-weight-bold">
          Isi Checklist
        </h4>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Form isi checklist harian/bulanan (§10.3)
        </p>
      </div>
    </div>

    <ChecklistFillForm :template-id="route.params.templateId" />
  </div>
</template>
